/* This file was generated automatically. Do not edit manually. */

export enum CancellationReason {
    Other = 'Other',
    ConfirmationMissed = 'ConfirmationMissed',
    BookedElsewhere = 'BookedElsewhere',
    ForceMajeure = 'ForceMajeure',
    GuestComplaint = 'GuestComplaint',
    NoShow = 'NoShow',
    PriceTooHigh = 'PriceTooHigh',
    ServiceNotAvailable = 'ServiceNotAvailable',
    InputError = 'InputError',
    InvalidPayment = 'InvalidPayment',
    TravelAgency = 'TravelAgency',
    RequestedByGuest = 'RequestedByGuest',
    Update = 'Update',
    BookingAbandoned = 'BookingAbandoned',
    RequestedByBooker = 'RequestedByBooker',
}
